export default __webpack_public_path__ + "344799994b1b5f9c7204f5c81b72cf7f.ttf";